import Vue from 'vue'
import VueRouter from 'vue-router'
import HelloWord from '@/components/HelloWorld'
import login from '@/components/login'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            redirect: {
                name: 'main'
            }
        },
        {path: '/main', name: 'main', component: HelloWord},
        {path: '/login', name: 'login', component: login},
    ]
})
router.beforeEach((to, _, next) => {
    if (to.path === "/login") {
        next();
    } else {
        const token = localStorage.getItem('token')
        if (token == null || token === "null" || token === "") {
            next("/login");
        } else {
            next();
        }
    }
})


export default router